import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=160314d1&scoped=true"
import script from "./invoice.vue?vue&type=script&lang=js"
export * from "./invoice.vue?vue&type=script&lang=js"
import style0 from "./invoice.vue?vue&type=style&index=0&id=160314d1&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160314d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('160314d1')) {
      api.createRecord('160314d1', component.options)
    } else {
      api.reload('160314d1', component.options)
    }
    module.hot.accept("./invoice.vue?vue&type=template&id=160314d1&scoped=true", function () {
      api.rerender('160314d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setting/pricing/invoice.vue"
export default component.exports